<template lang="pug">
v-snackbar(v-if="backendVer" :value="showVerNotify" fixed top right text color="white" multi-line :timeout="-1" vertical style="z-index: 1000")
  span
    v-icon.mr-2.white--text mdi-cog-outline
    span {{ $t('system_noti.reload_msg', {ver: backendVer})}}
  template(v-slot:action ="{ attrs }")
    v-btn.mr-3.white--text( small  color="grey darken-1" v-bind="attrs" @click="closeVerNotify(false)") {{ $t('system_noti.reload_later') }}
    v-btn( small color="success" v-bind="attrs" @click="closeVerNotify(true)") {{ $t('system_noti.reload_now') }}
</template>

<script lang="js">
import moment from 'moment'
import { defineComponent, getCurrentInstance, ref, watch } from 'vue'
import { useStore } from '@/utils/notifications'
import { system_version }from '@/../package.json'
import { hardReload } from '@/utils'

export default defineComponent({
  setup() {
    const currentVersion = ref(system_version)
    const { $root } = getCurrentInstance().proxy
    moment.locale('ja')
    const store = useStore()
    const showVerNotify = ref(false)

    const closeVerNotify = async (read  = false) => {
      if (read)
        hardReload()
      showVerNotify.value = false
    }
    watch(() => $root.$route, async () => {
      await store.getBackendVersion()
      if (store.backendVer.value && store.backendVer.value !== currentVersion.value ) {
        showVerNotify.value = true
      }
    })

    return {...store, currentVersion, showVerNotify, closeVerNotify}
  }
})
</script>

<style scoped lang="sass">
::v-deep
  .v-snack__wrapper
    background-color: #007cec !important
    max-width: 760px
  .v-snack--vertical .v-snack__wrapper .v-snack__action
    align-self: flex-center
</style>
